import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export default function SelectItem({
  checked,
  onChange,
  className,
  title,
  description,
  name,
  id,
  disabled,
}) {
  return (
    <label
      className={classnames('select-item', className, {
        'select-item--checked': checked,
        'select-item--disabled': disabled,
      })}
    >
      <div className="select-item__content">
        <input
          type="radio"
          className="select-item__input"
          checked={checked}
          onChange={onChange}
          name={name}
          id={id}
          disabled={disabled}
        />

        <span className="select-item__box">
          <span className="select-item__dot" />
        </span>

        {title ? <span className="select-item__title">{title}</span> : null}
      </div>

      {description ? <span className="select-item__description">{description}</span> : null}
    </label>
  )
}

SelectItem.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  disabled: PropTypes.bool,
}
